<template>
  <div>
    <b-row>
      <b-col class="text-center mb-4">
        <h5 v-if="isNew">Ajouter un copropriétaire</h5>
        <h5 v-else>Modifier un copropriétaire</h5>
      </b-col>
    </b-row>
    <b-row class="steps-tunnel mt-3 mb-5 justify-content-center">
      <b-col cols="10">
        <b-row>
          <!-- step1 btn -->
          <b-col cols="auto step-btn-block">
            <div class="step-text w-100 text-center">{{ "Informations personelles" }}</div>
            <b-button
              class="button btn-step"
              :class="{ 'btn-step-active': currentStep == 1 }"
              @click="changeStep(1)"
            >
              1
            </b-button>
          </b-col>
          <b-col class="step-line my-auto"></b-col>
          <!-- step2 btn -->
          <b-col cols="auto step-btn-block my-auto">
            <div class="step-text w-100 text-center">{{ "Lots" }}</div>
            <b-button
              class="button btn-step"
              :class="{ 'btn-step-active': currentStep == 2 }"
              :disabled="!step1ok && isNew"
              @click="changeStep(2)"
            >
              2
            </b-button>
          </b-col>
          <b-col class="step-line my-auto"></b-col>
          <!-- step3 btn -->
          <b-col cols="auto step-btn-block my-auto">
            <div class="step-text w-100 text-center">{{ "Tantièmes" }}</div>
            <b-button
              class="button btn-step my-auto"
              :class="{ 'btn-step-active': currentStep == 3 }"
              :disabled="!step2ok && isNew"
              @click="changeStep(3)"
            >
              3
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- .. -->
    <div v-if="!isLoadingInit" class="building-owner-block">
      <b-row class="justify-content-center">
        <b-col cols="10">
          <appStep1
            v-if="currentStep == 1"
            ref="step-1"
            :building-owner="buildingOwner"
            :all-countries="allCountries"
            :buildings-asl="buildingsAsl"
            @updateBuildingOwner="updateBuildingOwner"
          />
          <appStep2
            v-if="currentStep == 2"
            ref="step-2"
            :building-owner="buildingOwner"
            :building-id="buildingId"
            @updateBuildingOwner="updateBuildingOwner"
          />
          <appStep3
            v-if="currentStep == 3"
            :building-owner="buildingOwner"
            :building-id="buildingId"
            @updateBuildingOwner="updateBuildingOwner"
          />
        </b-col>
      </b-row>

      <!-- cancel, create, update -->
      <b-row class="mt-5 mb-2 justify-content-end">
        <b-col cols="auto">
          <b-button class="button btn-red" @click="cancel">
            <font-awesome-icon class="agv-button-icon" icon="times-circle" />
            <span>{{ $t("general.cancel") }}</span>
          </b-button>
        </b-col>
        <b-col cols="auto">
          <b-button
            v-if="isNew && currentStep !== 3"
            :disabled="isLoadingSave"
            class="button btn-blue"
            @click="goToNextStep"
          >
            <font-awesome-icon v-if="!isLoadingSave" class="agv-button-icon" icon="arrow-right" />
            <font-awesome-icon v-else class="agv-button-icon" icon="spinner" pulse />
            <span>{{ $t("general.continue") }}</span>
          </b-button>
          <b-button
            v-else
            :disabled="isLoadingSave"
            class="button btn-blue"
            @click="UPSERT_BUILDING_OWNER"
          >
            <font-awesome-icon v-if="!isLoadingSave" class="agv-button-icon" icon="save" />
            <font-awesome-icon v-else class="agv-button-icon" icon="spinner" pulse />
            <span>{{ $t("general.enregistrer") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </div>
    <appLoader v-else />
  </div>
</template>

<script>
import { validate } from "vee-validate";
import { mapState } from "vuex";

import appStep1 from "./Step1";
import appStep2 from "./Step2";
import appStep3 from "./Step3";

import BuildingOwnerMW from "@/middlewares/BuildingOwner";
import BuildingOwnerORM from "@/store/orm-axios/models/BuildingOwner";
import BuildingLotORM from "@/store/orm-axios/models/BuildingLot";
import BuildingOwnerBuildingLotORM from "@/store/orm-axios/models/BuildingOwnerBuildingLot";
import BuildingOwnerVotingRightORM from "@/store/orm-axios/models/BuildingOwnerVotingRight";
import MediaMW from "@/middlewares/Media";

var uuid = require("uuid");

export default {
  components: {
    appStep1,
    appStep2,
    appStep3,
  },
  props: {
    isNew: {
      type: Boolean,
      default: true,
    },
    buildingOwnerId: {
      type: String,
      default: "",
    },
    buildingId: {
      type: String,
      default: "",
    },
    allCountries: {
      type: Array,
      default: () => {
        return [];
      },
      required: true,
    },
    buildingsAsl: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      currentStep: 1,
      step1ok: false,
      step2ok: false,
      isLoadingInit: true,
      isLoadingSave: false,
      buildingOwner: {
        agency_id: Number(localStorage.getItem("agencyId")),
        building_id: this.buildingId,
        number: "",
        address: "",
        complement: "",
        complement2: "",
        zipcode: "",
        city: "",
        country: "FR",
        contact_type: 1,
        entity_type: 1,
        can_vote: 0,
        gender: 1,
        firstname: "",
        lastname: "",
        phone: "",
        email: "",
        building_lots: [],
        building_owner_building_lots: [],
        user_id: "",
        username: "",
        password: "",
        owner_left: 0,
        settings: {
          lre_agreement: false,
          lre_refusal: false,
          lre_agreement_media: null,
        },
        mediaFileToDelete: null,
        building_asl_id: null,
      },
    };
  },
  computed: {
    computedBuildingOwner() {
      return this.buildingOwner;
    },
    computedBuildingOwnerVotingRights() {
      let buildingOwnerVotingRight = [];
      this.$_.each(this.buildingOwner.building_lots, buildingLot => {
        if (buildingLot.pivot) {
          let item = BuildingOwnerVotingRightORM.query()
            .where("building_owner_has_building_lot_id", buildingLot.pivot.id)
            .get();
          if (item.length == 1) {
            buildingOwnerVotingRight.push(item[0]);
          } else if (item.length > 1) {
            buildingOwnerVotingRight = buildingOwnerVotingRight.concat(item);
          }
        } else {
          let item = BuildingOwnerVotingRightORM.query()
            .where(
              "building_owner_has_building_lot_id",
              buildingLot.building_owner_building_lots[0].id
            )
            .get();
          if (item.length == 1) {
            buildingOwnerVotingRight.push(item[0]);
          } else if (item.length > 1) {
            buildingOwnerVotingRight = buildingOwnerVotingRight.concat(item);
          }
        }
      });
      return buildingOwnerVotingRight;
    },
  },
  async created() {
    if (!this.isNew) {
      this.buildingOwner = null;
      await BuildingOwnerMW.GET(this.buildingOwnerId)
        .then(res => {
          this.isLoadingInit = false;
          this.buildingOwner = BuildingOwnerORM.query()
            .where("id", this.buildingOwnerId)
            .withAllRecursive()
            .first();
          // Set building_owner_has_voting_rights field for api
          this.buildingOwner.building_owner_has_voting_rights = this.computedBuildingOwnerVotingRights;
        })
        .catch(err => {
          this.isLoadingInit = false;
        });
      this.buildingOwner["buildingOwnerId"] = this.buildingOwnerId;
    } else {
      this.isLoadingInit = false;
    }
  },
  mounted() {
    // EX: position steps tunnel texts
    this.setStepTextsStyles();
  },
  beforeDestroy() {
    this.buildingOwner.building_lots = [];
    this.buildingOwner.building_owner_building_lots = [];
    BuildingLotORM.deleteAll();
    BuildingOwnerBuildingLotORM.deleteAll();
    BuildingOwnerORM.deleteAll();
    BuildingOwnerVotingRightORM.deleteAll();
  },
  methods: {
    updateBuildingOwner(key, value) {
      if (key === "settings" && typeof value === "object" && value !== null) {
        this.buildingOwner.settings = {
          ...this.buildingOwner.settings,
          ...value,
        };
      } else {
        this.buildingOwner[key] = value;
      }
    },
    async changeStep(stepNb) {
      if (!(await this.validateStep())) {
        return;
      }
      if (this.currentStep == 2) {
        if (this.buildingOwner.building_lots.length > 0) {
          this.currentStep = stepNb;
        } else {
          this.$swal({
            icon: "warning",
            title: "Veuillez ajouter au moins un lot !",
            showConfirmButton: true,
            timer: 3500,
          });
          return;
        }
      } else if (this.currentStep == 3) {
        if (this.buildingOwner.building_owner_has_voting_rights.length > 0) {
          for (
            let votingRight = 0;
            votingRight < this.buildingOwner.building_owner_has_voting_rights.length;
            votingRight++
          ) {
            if (this.buildingOwner.building_owner_has_voting_rights[votingRight].parts < 0) {
              return;
            }
          }
        } else {
          this.currentStep = stepNb;
        }
      } else {
        this.currentStep = stepNb;
      }
      this.currentStep = stepNb;
    },
    async goToNextStep() {
      let lastStep = this.currentStep;
      if (!(await this.validateStep())) {
        return;
      }
      if (this.currentStep == 1 && !this.step1ok) {
        this.CREATE_BUILDING_OWNER();
      } else {
        if (this.currentStep == 1) {
          this.step1ok = true;
          lastStep = 1;
          this.currentStep++;
        }
        if (
          lastStep != 1 &&
          lastStep != 3 &&
          this.currentStep == 2 &&
          this.buildingOwner.building_lots.length <= 0
        ) {
          this.$swal({
            icon: "warning",
            title: "Veuillez ajouter au moins un lot !",
            showConfirmButton: true,
            timer: 3500,
          });
        } else if (lastStep == 1 || lastStep == 3) {
          this.currentStep = 2;
        } else {
          this.step2ok = true;
          this.currentStep++;
        }
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    async CREATE_BUILDING_OWNER() {
      this.isLoadingSave = true;
      BuildingOwnerMW.REGISTER(this.buildingOwner).then(res => {
        this.buildingOwner.user_id = res.userId;
        this.buildingOwner.username = res.username;
        this.buildingOwner.password = res.password;
        this.isLoadingSave = false;
        this.step1ok = true;
        this.goToNextStep();
      });
    },
    async UPSERT_BUILDING_OWNER() {
      this.isLoadingSave = true;
      let totalParts = 0;
      // If is in edit mode, and building_owner_has_voting_rights is empty get parts from vuex
      if (
        !this.isNew &&
        (!this.buildingOwner.building_owner_has_voting_rights ||
          this.buildingOwner.building_owner_has_voting_rights.length == 0)
      ) {
        totalParts = this.getVotingParts();
      } else {
        for (
          let votingRight = 0;
          votingRight < this.buildingOwner.building_owner_has_voting_rights.length;
          votingRight++
        ) {
          if (this.buildingOwner.building_owner_has_voting_rights[votingRight].parts < 0) {
            return;
          } else if (this.buildingOwner.building_owner_has_voting_rights[votingRight].parts >= 0) {
            totalParts += this.buildingOwner.building_owner_has_voting_rights[votingRight].parts;
          }
        }
      }
      if (!(await this.validateStep())) {
        this.isLoadingSave = false;
        return;
      }
      if (this.currentStep == 2 && this.buildingOwner.building_lots.length <= 0) {
        this.$swal({
          icon: "warning",
          title: "Veuillez ajouter au moins un lot !",
          showConfirmButton: true,
          timer: 3500,
        });
        this.isLoadingSave = false;
        return;
      }
      if (
        this.currentStep == 3 &&
        this.buildingOwner.building_owner_has_voting_rights.length == 0
      ) {
        this.$swal({
          icon: "warning",
          title: "Veuillez ajouter au moins un droit de vote !",
          showConfirmButton: true,
          timer: 3500,
        });
        this.isLoadingSave = false;
        return;
      }
      if (totalParts == 0) {
        this.$swal({
          icon: "warning",
          title: "Veuillez ajouter au moins un tantièmes !",
          showConfirmButton: true,
          timer: 3500,
        });
        this.isLoadingSave = false;
        return;
      }

      // Need to check some of the properties to not be null
      this.buildingOwner.number =
        this.buildingOwner.number == null ? "" : this.buildingOwner.number;
      this.buildingOwner.complement =
        this.buildingOwner.complement == null ? "" : this.buildingOwner.complement;
      this.buildingOwner.complement2 =
        this.buildingOwner.complement2 == null ? "" : this.buildingOwner.complement2;
      this.buildingOwner.email = this.buildingOwner.email == null ? "" : this.buildingOwner.email;
      this.buildingOwner.firstname =
        this.buildingOwner.firstname == null ? "" : this.buildingOwner.firstname;
      this.buildingOwner.phone = this.buildingOwner.phone == null ? "" : this.buildingOwner.phone;
      BuildingOwnerMW.ADD_EDIT_COOWNER_PROCESS(this.buildingOwner)
        .then(res => {
          if (this.buildingOwner.mediaFileToDelete) {
            this.DELETE_MEDIA(this.buildingOwner.mediaFileToDelete);
          }
          this.isLoadingSave = false;
          this.cancel();
        })
        .catch(err => {
          this.isLoadingSave = false;
        });
    },
    async validateStep() {
      var valid = true;
      var values = [];
      var step = "";
      if (this.currentStep == 1) {
        step = "step-1";
        values = [
          {
            key: "lastname",
            rules: "required",
          },
          // ???: ??
          // {
          //   key: "firstname",
          //   rules: "required",
          // },
          {
            key: "email",
            rules:
              this.buildingOwner.contact_type == this.contactTypes.email ||
              (this.buildingOwner.settings && this.buildingOwner.settings.lre_agreement)
                ? "required"
                : "",
          },
          // {
          //   key: "street_nb",
          //   rules: "required",
          // },
          {
            key: "address",
            rules: "required",
          },
          {
            key: "zipcode",
            rules: this.buildingOwner.country == "FR" ? "required" : "",
          },
          {
            key: "city",
            rules: "required",
          },
          {
            key: "country",
            rules: "required",
          },
          {
            key: "contact_type",
            rules: "required",
          },
        ];
      }

      if (this.currentStep == 2) {
        step = "step-2";
        values = [
          // ???: ??
          // {
          //   key: "number",
          //   rules: "required",
          // },
        ];
      }

      for (let i = 0; i < values.length; i++) {
        await validate(this.buildingOwner[values[i].key], values[i].rules, {}).then(res => {
          if (!res.valid) {
            valid = false;
            this.$refs[step].$refs["vee-b-owner-" + values[i].key].validate();
          }
        });
      }
      return valid;
    },
    getVotingParts() {
      let parts = 0;
      this.buildingOwner.building_owner_building_lots.forEach(bOwnerBLot => {
        bOwnerBLot.building_owner_voting_rights.forEach(bOwnerVotRight => {
          parts += bOwnerVotRight.parts;
        });
      });
      return parts;
    },
    DELETE_MEDIA(media) {
      MediaMW.DELETE(media);
    },
  },
};
</script>
